import { kaiPartialIdPresenter } from '@kaiizen/kai-presenters';

import { ScanPhotoSyncRecord, useScanPhotoSyncModel } from '../Models';
import { useManageScanPhotosSync, usePhotoGallery } from '../Photos';
import { Syncer, SyncerProps, syncItemBatch } from './syncItemBatch';
import { SYNC_TIMEOUT_SECONDS } from './syncLib';

const DEFAULT_PHOTO_SYNC_CONCURRENCY = 5;

export const useScanPhotosSyncer = ({ syncLogger, addError, addSuccess, isPausedRef }: SyncerProps, concurrency?: number): Syncer<ScanPhotoSyncRecord> => {
  const photoSyncConcurrency = concurrency ?? DEFAULT_PHOTO_SYNC_CONCURRENCY;
  const { manageScanPhotosSync } = useManageScanPhotosSync();
  const photoGallery = usePhotoGallery();
  const model = useScanPhotoSyncModel();
  return {
    model,
    syncLogger,
    addError,
    isPausedRef,
    sync: pendingItems =>
      syncItemBatch({
        pendingItems,
        model,
        addError,
        addSuccess,
        syncLogger,
        isPausedRef,
        onCompletion: async stats => {
          if (stats.synced > 0) await manageScanPhotosSync();
        },
        syncOne: (scanId, item) =>
          syncLogger.withProgress(
            'photo ' + kaiPartialIdPresenter(item._id),
            onProgress => photoGallery.uploadPhoto(scanId, item._id, SYNC_TIMEOUT_SECONDS, onProgress),
          ),
        singleSyncConcurrencyLimit: photoSyncConcurrency,
      }),
  };
};
